// extracted by mini-css-extract-plugin
export default {"modal":"ProgressModal_modal__pISdk"};